import { format } from 'date-fns';
import React from 'react';
import uuid from 'uuid';

import { IMaterialDataTableItem, TValidContentTypes, IWithActionButtonProps } from '../../prop-types';
import StandardIcons from '../ActionIcons/StandardIcons';
import Visible from '../Visible';
import TableRow from '../table/TableRow';
import TableCell from '../table/TableCell';
import Check from '../svg/Check';
import Cancel from '../svg/Cancel';

interface IStandardRowProps extends IWithActionButtonProps {
  cells: IMaterialDataTableItem<TValidContentTypes>[];
  onEditClick: () => void;
  onDeleteClick: () => void;
  readOnly: boolean;
}

interface IOption {
  value: string;
  number: string;
}


const getCellContent = (
  content: TValidContentTypes,
): JSX.Element => {
    switch (typeof content) {
      case "boolean": {
        return content ? <Check /> : <Cancel />;
      }
      case "object": {
        return <span>{format(content, "dd. MMMM yyyy")}</span>;
      }
      default: {
        return <span>{content}</span>;
      }
  }
};

export default function StandardRow({
  cells,
  onEditClick = () => null,
  onDeleteClick = () => null,
  readOnly,
  ...props
}: IStandardRowProps) {
  return (
    <TableRow>
      <Visible if={!readOnly}>
        <TableCell>
          <StandardIcons
            onEditClick={onEditClick}
            onDeleteClick={onDeleteClick}
            {...props}
          />
        </TableCell>
      </Visible>
      <>
        {cells.map((rowItem) => (
          <TableCell key={uuid()} {...rowItem.props}>
            {getCellContent(rowItem.content)}
          </TableCell>
        ))}
      </>
    </TableRow>
  );
}
